import * as Sentry from '@sentry/react';
import { useErrorBoundary } from 'react-error-boundary';
import { useData } from '../../../../contexts/data-context/use-data';
import { ErrorSection } from '../../../../design-system/error-section/error-section';
import { LoadingSection } from '../../../../design-system/loading/loading';
import { OpenBankingPage } from './connect-open-banking-page';

export const OpenBankingPageWrapper = () => {
  const { data, isLoading: isLoadingData, error: dataError } = useData();
  const { showBoundary } = useErrorBoundary();

  if (isLoadingData) {
    return <LoadingSection text="Loading data..." />;
  }

  if (!data) {
    Sentry.addBreadcrumb({
      category: 'open_banking_wrapper',
      message: 'OpenBankingPageWrapper missing data',
      level: 'error',
      data: {
        hasError: !!dataError,
        errorMessage: dataError?.message || 'undefined',
        errorType: typeof dataError,
        isLoadingData,
        dataExists: !!data,
      },
    });

    return <ErrorSection error={dataError} />;
  }

  const { organisations, companies } = data;

  if (companies.length === 0) {
    Sentry.addBreadcrumb({
      data: {
        organisationId: organisations[0].id,
        message: 'No companies found',
      },
    });

    Sentry.addBreadcrumb({
      category: 'open_banking_wrapper',
      message: 'OpenBankingPageWrapper showing error boundary - no companies found',
      level: 'error',
      data: {
        organisationsCount: organisations.length,
        companiesCount: companies.length,
        hasOrganisations: organisations.length > 0,
      },
    });

    showBoundary(new Error('No companies found'));

    return;
  }

  return <OpenBankingPage companies={companies} />;
};
